import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import SendWhstappMessagepop from "../src/components/Dashboard/whatsapp/components/NewReplyPopUp";
// stanmax componenet
import StanmaxRoutes from "./components/Utils/StanmaxRoutes";
import StanmaxConv from "./components/Dashboard/stanmaxChildren/StanmaxConv";
// Pubulic View Component
import Login from "./components/site/Login";
import Signup from "./components/site/Signup";
import GoogleLogin from "./components/site/GoogleLogin";
import ForgotPassword from "./components/site/ForgotPassword";
// Admin view component
import Dashboard from "./components/Dashboard/Dashboard";
import Error from "../src/components/Dashboard/Error";

//Project Component
import CreateProject from "./components/Dashboard/project/CreateProject";
import ProjectList from "./components/Dashboard/project/ProjectList";
import EventList from "./components/Dashboard/event/EventList";

import FallbackList from "./components/Dashboard/fallback/FallbackList";

//Event Component
import CreateEvent from "./components/Dashboard/event/CreateEvent";
import CreateFallBack from "./components/Dashboard/fallback/CreateFallBack";
import CreateDirectEvent from "./components/Dashboard/event/CreateDirectEvent";
import ProjectEventList from "./components/Dashboard/project/ProjectEventList";

// Reports Component
import ReportsDetails from "./components/Dashboard/report/ReportsDetails";
import Reports from "./components/Dashboard/report/Reports";

// Template Component
import SmsTemplate from "./components/Dashboard/sms/SmsTemplate";
import VoiceTemplate from "./components/Dashboard/voice/VoiceTemplate";
import EmailTemplate from "./components/Dashboard/email/EmailTemplate";
import SmsTemplateList from "./components/Dashboard/sms/SmsTemplateList";
import DltTemplateList from "./components/Dashboard/dltSetup/DltTemplateList";
import VoiceTemplateList from "./components/Dashboard/voice/VoiceTemplateList";
import EmailTemplateList from "./components/Dashboard/email/EmailTemplateList";
import SmsReports from "./components/Dashboard/sms/SmsReports";
import EntityByPass from "./components/Admin/EntityByPass";

//Manage TTS
import TTSCreateGroup from "./components/Dashboard/voice/TTSCreateGroup";
import TTSUploadClip from "./components/Dashboard/voice/TTSUploadClip";
// import OBDDialing from "./components/Dashboard/voice/OBDDialing";
// import OBDReport from "./components/Dashboard/voice/OBDReport";
// import IVRReport from "./components/Dashboard/voice/IVRReport";

// Templates Component
import Template from "./components/Dashboard/Templates/Template";
import TemplateView from "./components/Dashboard/Templates/TemplateView";
import TemplateCreate from "./components/Dashboard/Templates/TemplateCreate";

// Profile Component
import AwsSetup from "./components/Dashboard/aws/AwsSetup";
import AwsFromEmail from "./components/Dashboard/aws/AwsFromEmail";
import MyProfile from "./components/Dashboard/profile/MyProfile";
import MyPlans from "./components/Dashboard/profile/MyPlans";
import ChangePassword from "./components/Dashboard/profile/ChangePassword";
import CreateSenderID from "./components/Dashboard/sms/CreateSenderID";
import EntityID from "./components/Dashboard/dltSetup/EntityID";
import TemplateManagement from "./components/Dashboard/dltSetup/TemplateManagement";
import Logout from "./components/site/Logout";
import TransactionPayment from "./components/Dashboard/profile/TransactionPayment";
import TransactionHistory from "./components/Dashboard/profile/TransactionHistory";
import PaymentSuccess from "./components/Dashboard/payment/PaymentSuccess";
import PaymentFail from "./components/Dashboard/payment/PaymentFail";
import BillingHistory from "./components/Dashboard/profile/BillingHistory";
import Support from "./components/Dashboard/support/Support";
import CreateNewTickets from "./components/Dashboard/support/CreateNewTickets";
import SupportHistory from "./components/Dashboard/support/SupportHistory";
import WebHook from "./components/Dashboard/webhook/WebHook";
import WebHookReport from "./components/Dashboard/webhook/WebHookReport";
import SmsPrice from "./components/Dashboard/sms/SmsPrice";
import SmsApiDashboard from "./components/Dashboard/sms/SmsApiDashboard";
// import RcsApiDashboard from "./components/Dashboard/rcs/RcsApiDashboard";
import WhatsAppAPIDashboard from "./components/Dashboard/whatsapp/WhatsAppAPIDashboard";
import RcsAPIDashboard from "./components/Dashboard/rcs/RcsAPIDashboard";
import SendSms from "./components/Dashboard/sms/SendSms";
import SmsDetailReports from "./components/Dashboard/sms/SmsDetailReports";
import SendVoice from "./components/Dashboard/voice/SendVoice";
import VoiceApiDashboard from "./components/Dashboard/voice/VoiceApiDashboard";
import VoicePriceList from "./components/Dashboard/voice/VoicePriceList";
import VoiceReports from "./components/Dashboard/voice/VoiceReports";
import VoiceDetailReports from "./components/Dashboard/voice/VoiceDetailReports";
import SendEmail from "./components/Dashboard/email/SendEmail";
import EmailApiDashboard from "./components/Dashboard/email/EmailApiDashboard";
import EmailPrice from "./components/Dashboard/email/EmailPrice";
import EmailReports from "./components/Dashboard/email/EmailReports";
import EmailDetailReports from "./components/Dashboard/email/EmailDetailReports";
import CallerID from "./components/Dashboard/voice/CallerID";
import DashboardAPi from "./components/Dashboard/apiDoc/DashboardAPi";
import EmailHTMLEditor from "./components/Dashboard/email/EmailHTMLEditor";
import EmailCampaign from "./components/Dashboard/email/EmailCampaign";
import EmailCampaningList from "./components/Dashboard/email/EmailCampaningList";
import EmailValidator from "./components/Dashboard/email/EmailValidator";
import EmailContact from "./components/Dashboard/email/EmailContact";
import NotificationStatus from "./components/Dashboard/profile/NotificationStatus";
import ViewAllNotifications from "./components/Dashboard/profile/ViewAllNotifications";
// import NotificationData from "./components/Dashboard/profile/NotificationData";
import PricingDetails from "./components/Dashboard/profile/PricingDetails";
import DownloadCentre from "./components/Dashboard/download/DownloadCentre";
import MarketPlace from "./components/Dashboard/marketPlace/MarketPlace";
import NumberOptOutlist from "./components/Dashboard/sms/NumberOptOutlist";

//whatsapp List components
import WhatsappEnabale from "./components/Dashboard/whatsapp/WhatsappEnabale";
import WhatsappEmbed from "./components/Dashboard/whatsapp/WhatsappEmbed";
import WhatsappNumberList from "./components/Dashboard/whatsapp/WhatsappNumberList";
import MetaEmbededSignup from "./components/Dashboard/MetaEmbededSignup";
import WhatsappTemplateList from "./components/Dashboard/whatsapp/WhatsappTemplateList";
import WhatsAppSummaryUser from "./components/Dashboard/whatsapp/WhatsAppSummaryUser";

import SendWhstappMessage from "./components/Dashboard/whatsapp/SendWhstappMessage";
import WhatsAppTemplate from "./components/Dashboard/whatsapp/WhatsAppTemplate";
import WhatsAppOptinOtpout from "./components/Dashboard/whatsapp/WhatsAppOptinOtpout";
import WhatsAppCountReports from "./components/Dashboard/whatsapp/WhatsAppCountReports";
import WhatsappDetailReports from "./components/Dashboard/whatsapp/WhatsappDetailReports";
import WhatsAppGallery from "./components/Dashboard/whatsapp/WhatsAppGallery";
import WhatsappConversation from "./components/Dashboard/whatsapp/WhatsappConversation";
import AgentList from "./components/Dashboard/whatsapp/agent/AgentList";
import AddAgent from "./components/Dashboard/whatsapp/agent/AddAgent";
import HuntStrategy from "./components/Dashboard/whatsapp/agent/HuntStrategy";
import ChatSetting from "./components/Dashboard/whatsapp/chat/ChatSetting";
import ChatReport from "./components/Dashboard/whatsapp/chat/ChatReport";
import Trigger from "./components/Dashboard/whatsapp/chat/Trigger";
import TriggerEdit from "./components/Dashboard/whatsapp/chat/TriggerEdit";
import Notifications from "./components/Dashboard/whatsapp/chat/Notifications";
import Webhooks from "./components/Dashboard/whatsapp/chat/Webhooks";
import ConfigureIntegration from "./components/Dashboard/Integration/ConfigureIntegration";
import UserMgmt from "./components/Dashboard/whatsapp/chat/UserMgmt";
import AgentReport from "./components/Dashboard/whatsapp/chat/AgentReport";
import AgentEdit from "./components/Dashboard/whatsapp/chat/AgentEdit";
import ChatConversation from "./components/Dashboard/whatsapp/chat/ChatConversation";
import ShortCut from "./components/Dashboard/whatsapp/chat/ShortCut";
import WhatsappWidget from "./components/Dashboard/whatsapp/WhatsappWidget";
import WhatsappWidgetSteps from "./components/Dashboard/whatsapp/WhatsappWidgetSteps";
import UserWidgetAnalytics from "./components/Dashboard/widget/UserWidgetAnalytics";
// import RemoveBranding from "./components/Dashboard/whatsapp/RemoveBranding";

//Confing Components
import Protected from "./components/Utils/Protected";
// Admin Components
import AdminProtected from "./components/Utils/AdminProtected";
import Admin from "./components/Admin/Admin";
import UserManagement from "./components/Admin/UserManagement";
import AllUserManagement from "./components/Admin/AllUserManagement";
import UserDetails from "./components/Admin/UserDetails";
import UserAddPrice from "./components/Admin/UserAddPrice";
import UserPriceDetails from "./components/Admin/UserPriceDetails";
import AwsSettings from "./components/Admin/AwsSettings";
import UserTransactionDetails from "./components/Admin/UserTransactionDetails";
import AddEmployee from "./components/Admin/AddEmployee";
// import AddSubAdmin from "./components/Admin/AddSubAdmin";
import TrafficManagement from "./components/Admin/TrafficManagement";
import EmployeeManagement from "./components/Admin/EmployeeManagement";
import AffiliateManagement from "./components/Admin/affiliate/AffiliateManagement";
import AffiliateCommision from "./components/Admin/affiliate/AffiliateCommision";
import AffiliatePayout from "./components/Admin/affiliate/AffiliatePayout";
import RouteManagement from "./components/Admin/RouteManagement";
import AddNewRoute from "./components/Admin/AddNewRoute";
import EditRoute from "./components/Admin/EditRoute";
import EditEmployee from "./components/Admin/EditEmployee";
import LoginHistory from "./components/Admin/LoginHistory";
import SignupHistory from "./components/Admin/SignupHistory";
import EntityHistory from "./components/Admin/EntityHistory";
import SernderHistory from "./components/Admin/SernderHistory";
import SmsTemplateHistory from "./components/Admin/SmsTemplateHistory";
import VoiceTemplateHistory from "./components/Admin/VoiceTemplateHistory";
import EmailTemplateHistory from "./components/Admin/EmailTemplateHistory";
import AwsSetupHistory from "./components/Admin/AwsSetupHistory";
import ApiRequest from "./components/Admin/ApiRequest";
import InvalidApiRequest from "./components/Admin/InvalidApiRequest";
import AddSpamWord from "./components/Admin/AddSpamWord";
import SpamReport from "./components/Admin/SpamReport";
import AddNewClient from "./components/Admin/AddNewClient";
// import SubAdmin from "./components/Admin/SubAdmin";
// import Permissions from "./components/Admin/Permissions";
import AddFaq from "./components/Admin/AddFaq";
import FaqList from "./components/Admin/FaqList";
import FeedBackMessage from "./components/Admin/FeedBackMessage";
import SupportTicket from "./components/Admin/SupportTicket";
import ViewTicket from "./components/Admin/ViewTicket";
import AdminTransactionHistory from "./components/Admin/TransactionHistory";
import ChangeRoute from "./components/Admin/ChangeRoute";
import ShiftRouter from "./components/Admin/ShiftRouter";
import ContactUsEnquiry from "./components/Admin/ContactUsEnquiry";
import ChangeCurrency from "./components/Admin/ChangeCurrency";
import AddBlackList from "./components/Admin/AddBlackList";
import AdminAnalytics from "./components/Admin/AdminAnalytics";
import AgentPlan from "./components/Admin/AgentPlan";
import AddAgentPlan from "./components/Admin/AddAgentPlan";
import AgentCoupon from "./components/Admin/AgentCoupon";
import AddAgentCoupon from "./components/Admin/AddAgentCoupon";
import AgentPlanList from "./components/Admin/AgentPlanList";
import AgentBill from "./components/Admin/AgentBill";
import AgentBillDetails from "./components/Admin/AgentBillDetails";
import YearlyPlanSettings from "./components/Admin/YearlyPlanSettings";
import YearlyAgentPlan from "./components/Admin/YearlyAgentPlan";
// import PlansList from "./components/Admin/PlansList";
import PartnerDashboard from "./components/Admin/PartnerDashboard";
import AiBotUsageOverview from "./components/Admin/AiBotUsageOverview";
import AssignPlan from "./components/Admin/plan/AssignPlan";
import DownloadHide from "./components/Admin/DownloadHide/DownloadHide";
import WhatsappProfile from "./components/Admin/whatsappManagement/WhatsappProfile";
import DefaultEmbededSignup from "./components/Admin/whatsappManagement/DefaultEmbededSignup";
import WhatsappSetting from "./components/Admin/whatsappManagement/WhatsappSetting";
import WhatsappSummary from "./components/Admin/whatsappManagement/WhatsappSummary";
import WhatsappSummaryApi from "./components/Admin/whatsappManagement/WhatsappSummaryApi";
import EmbededSignup from "./components/Admin/whatsappManagement/EmbededSignup";
import LcrRouteSetting from "./components/Admin/LcrRouteSetting";
import BillingSummary from "./components/Admin/BillingSummary";
import WhatsappSetup from "./components/Admin/whatsappManagement/WhatsappSetup";
import WhatsappSetupDetails from "./components/Admin/whatsappManagement/WhatsappSetupDetails";
import AdminMyProfile from "./components/Admin/AdminMyProfile";
import AdminNotification from "./components/Admin/AdminNotification";
import AdminChangePassword from "./components/Admin/AdminChangePass";
import UpdateWabaId from "./components/Admin/whatsappManagement/UpdateWabaId";
import AdminApiReport from "./components/Admin/AdminApiReport";
import AdminKarixReport from "./components/Admin/AdminKarixReport";
// rich Media admin component
import AddBlog from "./components/Admin/blog/AddBlog";
import BlogList from "./components/Admin/blog/BlogList";

// rich Media admin component
import RichMediaManagement from "./components/Admin/RichMediaManagement";
import RichMediaViewTemplate from "./components/Admin/RichMediaViewTemplate";

// Campaign component
import WhatsAppCampaign from "./components/Dashboard/campaign/WhatsAppCampaign";
import SmsCampaign from "./components/Dashboard/campaign/sms/SmsCampaign";
import CampaignList from "./components/Dashboard/campaign/CampaignList";
import CampaignPreview from "./components/Dashboard/campaign/CampaignPreview";
import CreateContactList from "./components/Dashboard/contactList/CreateContactList";
import ContactList from "./components/Dashboard/contactList/ContactList";
import ViewContactList from "./components/Dashboard/contactList/ViewContactList";
import UploadContactList from "./components/Dashboard/contactList/UploadContactList";
import CampaignReport from "./components/Dashboard/campaign/CampaignReport";
import CampaignReportWhatsApp from "./components/Dashboard/campaign/CampaignReportWhatsApp";
import CampaignSummayReport from "./components/Dashboard/campaign/CampaignSummayReport";
import RcsClickReportDetail from "./components/Dashboard/campaign/RcsClickReportDetail";

// rcs
//admin
import RcsAdminSetting from "./components/Admin/rcs/RcsSetting";
import RcsAdminSettingList from "./components/Admin/rcs/RcsSettingList";
// import RcsAdminFilter from "./components/Admin/rcs/RcsAdminFilter";
import AdminRcsOnboarding from "./components/Admin/rcs/AdminRcsOnboarding";
//outdated
import RcsApply from "./components/Dashboard/rcs/RcsApply";
import RcsApplyedList from "./components/Dashboard/rcs/RcsApplyedList";
import RcsTemplate from "./components/Dashboard/rcs/RcsTemplate";
import RcsReport from "./components/Dashboard/rcs/RcsReport";
import RcsDetailsReport from "./components/Dashboard/rcs/RcsDetailsReport";
import RcsAddAgent from "./components/Dashboard/rcs/RcsAddAgent";
import RcsAgentList from "./components/Dashboard/rcs/RcsAgentList";
import RcsPlan from "./components/Dashboard/rcs/RcsPlan";
import RcsSetting from "./components/Dashboard/rcs/RcsSetting";
import RcsTemplateList from "./components/Dashboard/rcs/RcsTemplateList";

import TestRichMedia from "./components/Dashboard/richMedia/TestRichMedia";
import RichMediaTemplateList from "./components/Dashboard/richMedia/RichMediaTemplateList";
import RichMediaTemplate from "./components/Dashboard/richMedia/TemplateRichMedia";
import RichMediaReport from "./components/Dashboard/richMedia/RichMediaReport";

import MyAccount from "./components/site/MyAccount";
import SignupSuccess from "./components/site/SignupSuccess";
import AgentForm from "./components/Dashboard/agent/AgentForm";
import AgentsLists from "./components/Dashboard/agent/AgentsLists";
import Automation from "./components/Dashboard/automation/Automation";
import AdminCampaignReport from "./components/Admin/AdminCampaignReport";
import WhatsappConvDownload from "./components/Dashboard/whatsapp/components/WhatsappConvDownload";
import { checkUserUrl } from "./components/Utils/Utils";
import otherfevicon from "./assets/favicon-defualt.png";
import WhatsappEnabaleNew from "./components/Dashboard/whatsapp/WhatsappEnableNew";
import EmbededSignupPinnacle from "./components/Dashboard/whatsapp/EmbededSignupPinnacle";
import PinnacleEmbededSignup from "./components/Admin/whatsappManagement/PinnacleEmbededSignup";
import PinnacleRegister from "./components/Admin/whatsappManagement/PinnacleRegister";
import PinnacleEmbededToken from "./components/Admin/whatsappManagement/PinnacleEmbededToken";
import SmsCampaignNew from "./components/Dashboard/campaign/sms/SmsCampaignNew";
import ResellerSetting from "./components/Setting/ResellerSetting";
import ReviewTemplate from "./components/Admin/ReviewTemplate";
import BulkSmsRouteSetting from "./components/Admin/BulkSmsRouteSetting";
import BlackList from "./components/Admin/BlackList";
import Optout from "./components/Dashboard/sms/Optout";
import WhatsAppTemplateAuthentication from "./components/Dashboard/whatsapp/WhatsappTemplateAuthentication";
import ProfileDetails from "./components/Admin/whatsappManagement/ProfileDetails";
import WhatsappTemplateSettingList from "./components/Admin/whatsappManagement/WhatsappTemplateSettingList";
import UpdateWhatsappToken from "./components/Admin/whatsappManagement/UpdateWhatsappToken";
import ChangeRouteSetting from "./components/Admin/whatsappManagement/ChangeRouteSetting";
import SmsCampaignReport from "./components/Admin/SmsCampaignReport";
import Settings from "./components/Dashboard/whatsapp/chat/Settings";
import Tag from "./components/Dashboard/whatsapp/chat/Tag";
import ResellerSignup from "./components/site/ResellerSignup";
import WhatsAppTemplateNew from "./components/Dashboard/whatsapp/WhatsappTemplateNew";
import CtaCampaignReport from "./components/Dashboard/campaign/CtaCampaignReport";
import EntityManagement from "./components/Admin/EntityMAnagement";
import WhatsappWidgetStatus from "./components/Admin/WhatsappWidgetStatus";
import WidgetAnalytics from "./components/Admin/widget/WidgetAnalytics";
import QueueStatusWhatsapp from "./components/Admin/QueueStatusWhatsapp";
import AdminBilling from "./components/Admin/AdminBilling";
import FixedUrl from "./components/Dashboard/UrlShortner/FixedUrl";
import FixedUrlReport from "./components/Dashboard/ClickReport/FixedUrlReport";
// import FixedUrlNew from "./components/Dashboard/ClickReportsNew/FixedUrlNew";
import FixedUrlFilterReport from "./components/Dashboard/ClickReport/FixedUrlFilterReport";
import { BASE_URL } from "./components/Dashboard/api/Api";
import RcsCampaign from "./components/Dashboard/campaign/Rcs/RcsCampaign";
import RcsTemplateNew from "./components/Dashboard/whatsapp/RcsTemplateNew";
import RcsTemplateList1 from "./components/Dashboard/whatsapp/RcsTemplateList";
import AdminRcsTemplateList from "./components/Admin/rcs/AdminRcsTemplateList";
import PreviewRcsTemplate from "./components/Admin/rcs/PreviewRcsTemplate";
import SendWhatsappMessageSingle from "./components/Dashboard/whatsapp/SendWhatsappMessageSingle";
import DocTest from "./components/DocTest";
import VendorSummary from "./components/Admin/VendorSummary";
import CtaReport from "./components/Dashboard/ClickReport/CtaReport";
import FlashCall from "./components/Dashboard/voice/FlashCall";
import FlashCallDetailReport from "./components/Dashboard/voice/FlashCallDetailReport";
import QuickReply from "./components/Dashboard/ClickReport/QuickReply";
import KarixEmbededSignup from "./components/Admin/whatsappManagement/KarixEmbededSignup";
import AgentLoginHistory from "./components/Dashboard/whatsapp/chat/AgentLoginHistory";
import AgentBilling from "./components/Dashboard/whatsapp/chat/AgentBilling";
import AgentBillingList from "./components/Dashboard/whatsapp/chat/AgentBillingList";
import RcsAdminCampaignReport from "./components/Admin/rcs/RcsAdminCampaignReport";
import RcsAdminDetailReport from "./components/Admin/rcs/RcsAdminDetailReport";
import BillingMode from "./components/Admin/BillingMode";
import ResellerPriceDetails from "./components/Admin/ResellerPriceDetails";
import ResellerAddPrice from "./components/Admin/ResellerAddPrice";
import ResellerTransactionDetails from "./components/Admin/ResellerTransactionDetails";
import RcsOnboarding from "./components/Dashboard/rcs/RcsOnboarding";
import TestWhatsappCampaign from "./components/Dashboard/campaign/TestWhatsappCampaign";
import TestSmsCampaign from "./components/Dashboard/campaign/sms/TestSmsCampaign";
import ContactListDtl from "./components/Dashboard/contactList/ContactListDtl";
import ResellerSiteSettings from "./components/Admin/ResellerSiteSettings";
// import ResellerEmailConfiguration from "./components/Admin/ResellerEmailConfiguration";
import ResellerDomainConfigure from "./components/Admin/ResellerDomainConfigure";
import ResellerPaymentGateway from "./components/Admin/ResellerPaymentGateway";
import UserBillingMode from "./components/Admin/UserBillingMode";
import WhatsAppCarouselTemplate from "./components/Dashboard/whatsapp/WhatsappCarouselTemplate";
import FacebookLeads from "./components/Dashboard/contactList/FacebookLeads";
import ShopifyWebhook from "./components/Dashboard/webhook/ShopifyWebhook";
import TwoFactorAuth from "./components/Dashboard/profile/TwoFactorAuth";
import PageNotFound from "./components/Dashboard/PageNotFound";
import EmployeeWhatsappOnboardingList from "./components/Admin/whatsappManagement/EmployeeWhatsappOnboardingList";
// import EmployeesCampaignReport from "./components/Admin/EmployeesCampaignReport";
import ApiReport from "./components/Admin/ApiReport";
import ConversationReport from "./components/Admin/ConversationReport";
import ResellerBillingHistory from "./components/Admin/ResellerBillingHistory";
import EmployeesCampaignReport from "./components/Admin/EmployeesCampaignReport";
import EntityChainManagement from "./components/Admin/EntityChainManagement";
import ResellerHierarchy from "./components/Admin/ResellerHierarchy";
import QuestionnaireList from "./components/Admin/QuestionnaireList";
import ManageClip from "./components/Admin/ManageClip";
import ClipList from "./components/Admin/ClipList";
import WhatsappWidgetData from "./components/Dashboard/whatsapp/WhatsappWidgetData";
import WhatsappWidgetQR from "./components/Dashboard/whatsapp/WhatsAppWidgetQR";
import AdminTransactionPayment from "./components/Admin/AdminTransactionPayment";
import BillingReport from "./components/Admin/BillingReport";
import RcsOnboardingList from "./components/Admin/rcs/RcsOnboardingList";
import RcsRequestDetails from "./components/Admin/rcs/RcsRequestDetails";
import TemplateLibrary from "./components/Dashboard/whatsapp/components/TemplateLibrary";
import EncryptionSetting from "./components/Admin/EncryptionSetting";
import ApiAutoshortUrl from "./components/Admin/ApiAutoshortUrl";

import ExtraSettings from "./components/Admin/ExtraSettings";
import AdminCampaignSummaryReport from "./components/Admin/AdminCampaignSummaryReport";
import ConversationDownload from "./components/Dashboard/ConversationDownload";
import AdminSmsDetailReport from "./components/Admin/AdminSmsDetailReport";
import Mmlite from "./components/Admin/Mmlite";
import AiBot from "./components/Admin/AiBot";
import MmliteRequest from "./components/Admin/MmliteRequest";
import MmliteStatus from "./components/Admin/MmliteStatus";
// import IVRSetting from "./components/Admin/IVRSetting";
import UserMain from "./components/Admin/UserMain";
// import CustomerDataPlatform from "./components/Admin/CustomerDataPlatform";
import AdminBillingReport from "./components/Admin/AdminBillingReport";
// import EstimateReport from "./components/Admin/EstimateReport";
import KarixMmliteSignup from "./components/Admin/whatsappManagement/KarixMmliteSignup";
import KarixSignupAdz from "./components/Admin/whatsappManagement/KarixSignupAdz";
import AdminBillingTransactionHistory from "./components/Admin/AdminBillingTransactionHistory";
import TestSignup from "./components/site/TestSignup";
import ResellerTransactionHistory from "./components/Admin/ResellerTransactionHistory";
import TrackUrl from "./components/Dashboard/UrlShortner/TrackUrl";
import ShortUrlReport from "./components/Dashboard/ClickReport/ShortUrlReport";
import CtaDetailReport from "./components/Dashboard/ClickReport/CtaDetailReport";
import TestSmsCampaign2 from "./components/Dashboard/campaign/sms/TestSmsCampaign2";
import ScheduleReport from "./components/Dashboard/campaign/ScheduleReport";
import ScheduleCampaign from "./components/Admin/ScheduleCampaign";
import Workflow from "./components/Dashboard/Workflow";
// import UsermanagementDemo from "./components/Admin/UsermanagementDemo";
import SerriEmbededSignup from "./components/Admin/whatsappManagement/SerriEmbededSignup";
import DeleteBouncedList from "./components/Admin/DeleteBouncedList";
import FormBuilder from "./components/Dashboard/formBuilder/FormBuilder";
import FormList from "./components/Dashboard/formBuilder/FormList";
import FormView from "./components/Dashboard/formBuilder/FormView";
// import UserDashboard from "./components/Admin/UserDashboard";
// import CustomerDataDashboard from "./components/Dashboard/contactList/CustomerDataDashboard/CustomerDataDasboard";
import NotificationSetting from "./components/Admin/NotificationSetting";
import EmailVerification from "./components/Dashboard/Emailverification/EmailVerification";
import Verificationreport from "./components/Dashboard/Emailverification/Verificationreport";
import CrossOrigin from "./components/Admin/CrossOrigin/CrossOrigin";
import { Cross } from "recharts";
// import EmployeesCampaignSummary from "./components/Admin/EmployeeCampaignSummary";
import SmsTemplateSummary from "./components/Dashboard/sms/SmsTemplateSummary";
import AdminIntegrationPanel from "./components/Admin/AdminIntegrationPanel";
import AdminEventPanel from "./components/Admin/AdminEventPanel";
import WorkflowList from "./components/Dashboard/WorkflowList";
import AdminDownloadCentre from "./components/Admin/AdminDownloadCenter";
import QuickReplySummary from "./components/Dashboard/ClickReport/QuickReplySummary";
import CdpSearch from "./components/Admin/CDP Search/CdpSearch";
import Usercdp from "./components/Dashboard/whatsapp/components/Usercdp";
import Telemarketer from "./components/Admin/Telemarketer";
import ManageProduct from "./components/Dashboard/ManageProduct";
import MyOrder from "./components/Dashboard/MyOrder";
import PaymentGatewaySetup from "./components/Dashboard/PaymentGatewaySetup";
import ApiFailedRequest from "./components/Admin/ApiFailedRequest";
import UserApiFailedRequest from "./components/Dashboard/UserApiFailedRequest";
import PaymentGatewayList from "./components/Admin/PaymentGatewayList";
import Useractivitylog from "./components/Admin/Useractivitylog";
import UserJourney from "./components/Admin/UserJourney";
import ActivityLogBuckets from "./components/Admin/ActivityLogBuckets";
// import UserTwoFactorAuth from "./components/Dashboard/profile/UserTwoFactorAuth";
import WhatsappFlowBuilder from "./components/Dashboard/WhatsappFlowBuilder";
import WhatsappFlowTracker from "./components/Dashboard/WhatsappFlowTracker";
// import RcsClickReportDetail from "./components/Dashboard/campaign/RcsClickReportDetail";

import Instagram from "./components/Dashboard/Instagram/Instagram";
import InstagramConversation from "./components/Dashboard/Instagram/InstagramConversation";
import InstagramAutomationSetup from "./components/Dashboard/Instagram/InstagramAutomationSetup";
import InstagramReport from "./components/Dashboard/Instagram/InstagramReport";
import Facebook from "./components/Dashboard/Facebook/Facebook";

import UserPlanManagement from "./components/Admin/UserPlan/UserPlanManagement";
import UserPlanList from "./components/Admin/UserPlan/UserPlanList";
import EditUserPlan from "./components/Admin/UserPlan/EditUserPlan";

// Analytics and Reports new components
// import AnalyticsDashboard from "./components/Dashboard/AnalyticsReportsNew/AnalyticsDashboard";

function App() {
  const [urlStatus, setUrlStatus] = useState(false);
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const url = document.location.href;
  let userId;

  if (lStorage) {
    userId = lStorage.user.userId;
  } else {
    userId = null;
  }

  useEffect(() => {
    const domain = window.location.host;

    if (domain !== BASE_URL && domain !== "localhost:3000") {
      const link =
        document.querySelector("link[rel='icon']") ||
        document.createElement("link");
      link.rel = "icon";
      link.href = otherfevicon;
      document.head.appendChild(link);
    }
  }, []);

  useEffect(() => {
    const domain = window.location.host;

    if (domain === BASE_URL || domain === "localhost:3000") {
      setUrlStatus(true);
    } else {
      setUrlStatus(false);
    }
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const handleKeyDown = (e) => {
      // Disable F12
      if (e.key === "F12") {
        e.preventDefault();
      }

      // Disable Ctrl+Shift+I (DevTools shortcut)
      if (e.ctrlKey && e.shiftKey && e.key === "I") {
        e.preventDefault();
      }

      // Disable Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.key === "J") {
        e.preventDefault();
      }

      // Disable Ctrl+U (View Page Source)
      //console.log("error")
      if (e.ctrlKey && e.key === "u") {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div>
      <Router>
        <Switch>
          <Route
            exact
            path="/login"
            render={(props) =>
              urlStatus ? <Login {...props} /> : <MyAccount {...props} />
            }
          ></Route>

          <Route exact path="/login/google" component={GoogleLogin} />
          <Route path="/signup-success" component={SignupSuccess} />
          <Route path="/doc-test" component={DocTest} />
          {/* <Route
            exact
            path="/"
            render={(props) =>  urlStatus ? <Login {...props} /> : <MyAccount {...props} />
            }
          ></Route> */}
          <Route
            exact
            path="/"
            render={(props) => {
              const params = new URLSearchParams(props.location.search);
              const code = params.get("code");
              const error = params.get("error");
              const state = params.get("state");

              if (code || error) {
                if (code) {
                  sessionStorage.setItem("instagram_auth_code", code);
                }

                if (state) {
                  sessionStorage.setItem("instagram_auth_state", state);
                }

                if (error) {
                  sessionStorage.setItem("instagram_auth_error", error);
                }

                return <Redirect to="/dashboard/instagram" />;
              }

              return urlStatus ? (
                <Login {...props} />
              ) : (
                <MyAccount {...props} />
              );
            }}
          ></Route>
          <Route
            path="/my-account"
            render={(props) => <MyAccount {...props} />}
          ></Route>
          <Route exact path="/signup">
            <Signup />
          </Route>
          <Route exact path="/test-signup">
            <TestSignup />
          </Route>
          <Route
            path="/resellersignup"
            render={(props) => <ResellerSignup {...props} />}
          ></Route>
          <Route path="/forgot-password">
            <ForgotPassword />
          </Route>
          {/* Dashboard Routes */}
          <StanmaxRoutes
            exact
            path="/stanmax/whatsappconv"
            component={StanmaxConv}
          />
          <Protected exact path="/dashboard" component={Dashboard} />
          {/* <Protected
            exact
            path="/dashboard/automation"
            component={Automation}
          /> */}
          <Protected
            exact
            path="/dashboard/create-project"
            component={CreateProject}
          />
          <Protected
            exact
            path="/dashboard/wpdemo"
            component={SendWhstappMessagepop}
          />
          <Protected
            exact
            path="/dashboard/create-event"
            component={CreateDirectEvent}
          />
          <Protected
            exact
            path="/dashboard/project-list"
            component={ProjectList}
          />
          <Protected exact path="/dashboard/event-list" component={EventList} />
          <Protected
            exact
            path="/dashboard/fallback-list"
            component={FallbackList}
          />
          <Protected
            exact
            path="/dashboard/create-agent"
            component={AgentForm}
          />
          <Protected
            exact
            path="/dashboard/agent-list"
            component={AgentsLists}
          />
          <Protected
            exact
            path="/dashboard/chat-report"
            component={ChatReport}
          />
          <Protected
            exact
            path="/dashboard/chat-setting/trigger"
            component={Trigger}
          />
          <Protected exact path="/dashboard/chat-setting/tag" component={Tag} />
          <Protected
            exact
            path="/dashboard/chat-setting/trigger/trigger-edit"
            component={TriggerEdit}
          />
          <Protected
            exact
            path="/dashboard/chat-setting"
            component={Settings}
          />
          <Protected
            exact
            path="/dashboard/agent-login-history"
            component={AgentLoginHistory}
          />
          <Protected
            exact
            path="/dashboard/agent-billing-edit/:name"
            component={AgentBillingList}
          />
          <Protected
            exact
            path="/dashboard/agent-billing"
            component={AgentBilling}
          />
          <Protected
            exact
            path="/dashboard/notifications"
            component={Notifications}
          />
          <Protected
            exact
            path="/dashboard/chat-setting/webhooks"
            component={Webhooks}
          />
          <Protected
            exact
            path="/dashboard/user-management/:id"
            component={UserMgmt}
          />
          <Protected
            exact
            path="/dashboard/chat-report/agent-report/:id"
            component={AgentReport}
          />
          <Protected exact path="/dashboard/add-agent" component={AgentEdit} />
          <Protected
            exact
            path="/dashboard/agent/edit/:id"
            component={AgentEdit}
          />
          <Protected
            exact
            path="/dashboard/chat-conversation"
            component={ChatConversation}
          />
          <Protected exact path="/dashboard/shortcut" component={ShortCut} />
          <Protected
            exact
            path="/dashboard/opt-out-list"
            component={NumberOptOutlist}
          />
          <Protected
            exact
            path="/dashboard/sms-template"
            component={SmsTemplate}
          />
          <Protected
            exact
            path="/dashboard/voice-template"
            component={VoiceTemplate}
          />
          <Protected
            exact
            path="/dashboard/tts-create-group"
            component={TTSCreateGroup}
          />
          <Protected
            exact
            path="/dashboard/tts-upload-clip"
            component={TTSUploadClip}
          />
          {/* <Protected
            exact
            path="/dashboard/obd-dialing"
            component={OBDDialing}
          />
           <Protected
            exact
            path="/dashboard/obd-report"
            component={OBDReport}
          /> */}
          {/* <Protected
            exact
            path="/dashboard/ivr-report"
            component={IVRReport}
          /> */}
          <Protected
            exact
            path="/dashboard/email-template"
            component={EmailTemplate}
          />
          <Protected
            exact
            path="/dashboard/sms-template-list"
            component={SmsTemplateList}
          />
          <Protected
            exact
            path="/dashboard/template"
            component={Template}
          />
          <Protected
            exact
            path="/dashboard/template-view"
            component={TemplateView}
          />
          <Protected
            exact
            path="/dashboard/template-create"
            component={TemplateCreate}
          />
          <Protected
            exact
            path="/dashboard/dlt-template-list"
            component={DltTemplateList}
          />
          <Protected
            exact
            path="/dashboard/voice-template-list"
            component={VoiceTemplateList}
          />
          <Protected
            exact
            path="/dashboard/email-template-list"
            component={EmailTemplateList}
          />
          <Protected
            exact
            path="/dashboard/details-reports"
            component={ReportsDetails}
          />
          <Protected exact path="/dashboard/reports" component={Reports} />
          <Protected exact path="/dashboard/my-profile" component={MyProfile} />
          <Protected exact path="/dashboard/my-plans" component={MyPlans} />
          <Protected
            exact
            path="/dashboard/change-password"
            component={ChangePassword}
          />
          <Protected
            exact
            path="/dashboard/two-factor-authentication"
            component={TwoFactorAuth}
          />
          <Protected exact path="/dashboard/aws-setup" component={AwsSetup} />
          <Protected
            exact
            path="/dashboard/create-sender-id"
            component={CreateSenderID}
          />
          <Protected
            exact
            path="/dashboard/add-entity-id"
            component={EntityID}
          />
          <Protected
            exact
            path="/dashboard/template-management"
            component={TemplateManagement}
          />
          <Protected
            exact
            path="/dashboard/aws-email-verify"
            component={AwsFromEmail}
          />
          <Protected
            exact
            path="/dashboard/transaction-payment"
            component={TransactionPayment}
          />
          <Protected
            exact
            path="/dashboard/transaction-history"
            component={TransactionHistory}
          />
          <Protected
            exact
            path="/dashboard/payment-success"
            component={PaymentSuccess}
          />
          <Protected
            exact
            path="/dashboard/payment-failed"
            component={PaymentFail}
          />
          <Protected
            exact
            path="/dashboard/price-list"
            component={BillingHistory}
          />
          <Protected exact path="/dashboard/support" component={Support} />
          <Protected
            exact
            path="/dashboard/create-new-ticket"
            component={CreateNewTickets}
          />
          <Protected
            exact
            path="/dashboard/configure-webhook"
            component={WebHook}
          />
          <Protected
            exact
            path="/dashboard/webhook-report"
            component={WebHookReport}
          />
          <Protected exact path="/dashboard/workflow" component={Workflow} />
          <Protected
            exact
            path="/dashboard/workflow-list"
            component={WorkflowList}
          />
          {/* <Protected
            exact
            path="/dashboard/workflow-edit/:id"
            component={Workflow}
          /> */}
          <Protected
            exact
            path="/dashboard/shopify-webhook"
            component={ShopifyWebhook}
          />
          <Protected
            exact
            path="/dashboard/configure-integration"
            component={ConfigureIntegration}
          />

          <Protected
            exact
            path="/dashboard/sms-price-list"
            component={SmsPrice}
          />
          <Protected
            exact
            path="/dashboard/sms-api-docs"
            component={SmsApiDashboard}
          />
          {/* <Protected
            exact
            path="/dashboard/rcs-api-docs"
            component={RcsApiDashboard}
          /> */}
          <Protected
            exact
            path="/dashboard/whatsapp-api-docs"
            component={WhatsAppAPIDashboard}
          />
          <Protected
            exact
            path="/dashboard/rcs-api-docs"
            component={RcsAPIDashboard}
          />
          <Protected
            exact
            path="/dashboard/api-failed-request"
            component={UserApiFailedRequest}
          />
          {/* <Protected
            exact
            path="/dashboard/user-two-factor-authentication"
            component={UserTwoFactorAuth}
          /> */}
          <Protected
            exact
            path="/dashboard/manage-product"
            component={ManageProduct}
          />
          <Protected
            exact
            path="/dashboard/orders"
            component={MyOrder}
          />
          <Protected
            exact
            path="/dashboard/my-order"
            component={RcsAPIDashboard}
          />
          <Protected
            exact
            path="/dashboard/payment-gateway"
            component={PaymentGatewaySetup}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-flow-builder"
            component={WhatsappFlowBuilder}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-flow-builder-tracker/:id"
            component={WhatsappFlowTracker}
          />
          <Protected
            exact
            path="/dashboard/payment-history"
            component={RcsAPIDashboard}
          />
          <Protected
            exact
            path="/dashboard/sample-template-library"
            component={TemplateLibrary}
          />
          <Protected exact path="/dashboard/send-sms" component={SendSms} />
          <Protected
            exact
            path="/dashboard/sms-report"
            component={SmsReports}
          />
          <Protected exact path="/dashboard/optout" component={Optout} />
          <Protected
            exact
            path="/dashboard/email-report"
            component={EmailReports}
          />
          <Protected
            exact
            path="/dashboard/campaign/rcs-click-report/:templateId/:fromDate/:toDate"
            component={RcsClickReportDetail}
          />
          <Protected exact path="/dashboard/send-voice" component={SendVoice} />
          <Protected
            exact
            path="/dashboard/voice-api-docs"
            component={VoiceApiDashboard}
          />
          <Protected
            exact
            path="/dashboard/voice-price-list"
            component={VoicePriceList}
          />
          <Protected
            exact
            path="/dashboard/voice-report"
            component={VoiceReports}
          />
          <Protected exact path="/dashboard/flash-call" component={FlashCall} />
          <Protected exact path="/dashboard/send-email" component={SendEmail} />
          <Protected
            exact
            path="/dashboard/email-api-docs"
            component={EmailApiDashboard}
          />
          <Protected
            exact
            path="/dashboard/email-price"
            component={EmailPrice}
          />
          <Protected
            exact
            path="/dashboard/send-whatsapp-single"
            component={SendWhatsappMessageSingle}
          />
          <Protected exact path="/dashboard/caller-id" component={CallerID} />
          <Protected
            exact
            path="/dashboard/api-docs"
            component={DashboardAPi}
          />
          <Protected
            exact
            path="/dashboard/rcs-campaign"
            component={RcsCampaign}
          />
          <Protected
            exact
            path="/dashboard/email-campaning"
            component={EmailCampaign}
          />
          <Protected
            exact
            path="/dashboard/email-contact"
            component={EmailContact}
          />
          <Protected
            exact
            path="/dashboard/email-campaning-list"
            component={EmailCampaningList}
          />
          <Protected
            exact
            path="/dashboard/email-validator"
            component={EmailValidator}
          />
          <Protected
            exact
            path="/dashboard/notification"
            component={NotificationStatus}
          />
          <Protected
            exact
            path="/dashboard/view-all-notifications"
            component={ViewAllNotifications}
          />

           {/* <Protected
            exact
            path="/dashboard/notification-data"
            component={NotificationData}
          /> */}
          <Protected
            exact
            path="/dashboard/pricing-details"
            component={PricingDetails}
          />
          <Protected
            exact
            path="/dashboard/download-centre"
            component={DownloadCentre}
          />
          <Protected
            exact
            path="/dashboard/marketplace"
            component={MarketPlace}
          />

          <Protected exact path="/dashboard/instagram" component={Instagram} />
          <Protected
            exact
            path="/dashboard/instagram-conversations"
            component={InstagramConversation}
          />
          <Protected
            exact
            path="/dashboard/instagram-automation"
            component={InstagramAutomationSetup}
          />
          <Protected
            exact
            path="/dashboard/instagram-report"
            component={InstagramReport}
          />

          <Protected exact path="/dashboard/facebook" component={Facebook} />

          <AdminProtected exact path="/admin/user-plan-management" component={UserPlanManagement} />
          <AdminProtected exact path="/admin/user-plan-list" component={UserPlanList} />
          <AdminProtected exact path="/admin/edit-user-plan/:id/:userType" component={EditUserPlan} />


      
          <Protected
            exact
            path="/dashboard/campaign-start"
            component={WhatsAppCampaign}
          // component={TestWhatsappCampaign}
          />
          <Protected
            exact
            path="/dashboard/test-campaign-start"
            component={TestWhatsappCampaign}
          />
          <Protected
            exact
            path="/dashboard/sms-campaign-start"
            component={SmsCampaign}
          />
          <Protected
            exact
            path="/dashboard/sms-campaign"
            // component={SmsCampaignNew}
            component={TestSmsCampaign2}
          />
          <Protected
            exact
            path="/dashboard/test-sms-campaign"
            component={TestSmsCampaign2}
          />
          <Protected
            exact
            path="/dashboard/create-contact-list"
            component={CreateContactList}
          />
          <Protected
            exact
            path="/dashboard/contact-list"
            component={ContactList}
          />
          <Protected
            exact
            path="/dashboard/facebook-leads"
            component={FacebookLeads}
          />
          <Protected exact path="/dashboard/fixed-url" component={FixedUrl} />
          <Protected exact path="/dashboard/track-url" component={TrackUrl} />
          <Protected
            exact
            path="/dashboard/fixed-url-report"
            component={FixedUrlReport}
          />
          {/* <Protected
            exact
            path="/dashboard/fixed-url-new"
            component={FixedUrlNew}
          /> */}
          <Protected
            exact
            path="/dashboard/EmailVerification"
            component={EmailVerification}
          />
          <Protected
            exact
            path="/dashboard/email-verification-report/:filter_type/:startdate/:enddate"
            component={Verificationreport}
          />
          <Protected
            exact
            path="/dashboard/short-url-report"
            component={ShortUrlReport}
          />
          <Protected exact path="/dashboard/cta" component={CtaReport} />
          <Protected
            exact
            path="/dashboard/cta-detail-report/:startDate/:endDate/:submitVia/:campId/:btnName"
            component={CtaDetailReport}
          />
          <Protected
            exact
            path="/dashboard/quick-reply"
            component={QuickReply}
          />
          <Protected
            exact
            path="/dashboard/quick-reply-summary/:channel/:fromdate/:todate/:submit/:mainurl/:contextid"
            component={QuickReplySummary}
          />
          <Protected
            exact
            path="/dashboard/fixed-url-report/:channel/:startdate/:enddate/:url"
            component={FixedUrlFilterReport}
          />
          <Protected
            exact
            path="/dashboard/campaign"
            component={CampaignList}
          />
          <Protected
            exact
            path="/dashboard/schedule-report"
            component={ScheduleReport}
          />
          <Route
            path="/dashboard/campaign/view/:id"
            render={(props) => <CampaignPreview {...props} />}
          ></Route>
          <Route
            path="/dashboard/upload-contact-list/:id/:list_type/:list_name?"
            render={(props) => <UploadContactList {...props} />}
          ></Route>
          <Route
            exact
            path="/dashboard/view-contact-list/:id/:list_type/:list_name?"
            render={(props) => <ViewContactList {...props} />}
          ></Route>
          <Route
            exact
            path="/dashboard/view-contact-list/:id/:list_type/:mob/:ref"
            render={(props) => <ContactListDtl {...props} />}
          ></Route>
          <Route
            path="/dashboard/campaign/detailed-report/:channel/:id/:campaignName/:totalData"
            render={(props) => <CampaignReport {...props} />}
          ></Route>
          <Route
            path="/dashboard/campaign/cta-report/:id"
            render={(props) => <CtaCampaignReport {...props} />}
          ></Route>
          <Route
            path="/dashboard/campaign/rcs-click-report/:templateId/:fromDate/:toDate"
            render={(props) => <RcsClickReportDetail {...props} />}
          ></Route>
          <Route
            path="/dashboard/campaign/summary-report/:channel/:id/:campaignName"
            render={(props) => <CampaignSummayReport {...props} />}
          ></Route>
          {/* WhatsAPP Rought */}
          <Protected
            exact
            path="/dashboard/whatsapp-onboarding"
            component={WhatsappEnabale}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-onboarding-new"
            component={WhatsappEnabaleNew}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-onboarding/embedded"
            component={EmbededSignupPinnacle}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-embed"
            component={WhatsappEmbed}
          />
          <Protected
            exact
            path="/dashboard/whatsapp"
            component={WhatsappNumberList}
          />
          <Protected
            exact
            path="/dashboard/meta-embedded-signup"
            component={MetaEmbededSignup}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-summary"
            component={WhatsAppSummaryUser}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-template-list"
            component={WhatsappTemplateList}
          />
          <Protected
            exact
            path="/dashboard/create-whatsapp-carousel-template"
            component={WhatsAppCarouselTemplate}
          />
          {/* <Protected
            exact
            path="/dashboard/create-rcs-template"
            component={RcsTemplate}
          /> */}
          <Protected
            exact
            path="/dashboard/rcs-template-list"
            component={RcsTemplateList}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-conversation"
            component={WhatsappConversation}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-conversation/download"
            component={WhatsappConvDownload}
          />
          <Protected
            exact
            path="/dashboard/wp-agent-list"
            component={AgentList}
          />
          <Protected
            exact
            path="/dashboard/add-wp-agent"
            component={AddAgent}
          />
          <Protected
            exact
            path="/dashboard/agent-setting"
            component={HuntStrategy}
          />
          <Protected
            exact
            path="/dashboard/send-whatsapp"
            component={SendWhstappMessage}
          />
          <Protected
            exact
            path="/dashboard/create-whatsapp-template"
            component={WhatsAppTemplateNew}
          />
          <Protected
            exact
            path="/dashboard/create-whatsapp-template-new"
            component={WhatsAppTemplate}
          />
          <Route
            path="/dashboard/preview-whatsapp-template-new/:id"
            render={(props) => <WhatsAppTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/preview-carousel-whatsapp-template/:id"
            render={(props) => <WhatsAppCarouselTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/duplicate-whatsapp-template-new/:templateid"
            render={(props) => <WhatsAppTemplate {...props} />}
          ></Route>
          <Protected
            exact
            path="/dashboard/create-whatsapp-template-authentication"
            component={WhatsAppTemplateAuthentication}
          />
          <Route
            path="/dashboard/preview-whatsapp-template/:id"
            render={(props) => <WhatsAppTemplateNew {...props} />}
          ></Route>
          <Route
            path="/dashboard/duplicate-whatsapp-template/:templateid"
            render={(props) => <WhatsAppTemplateNew {...props} />}
          ></Route>
          <Route
            path="/dashboard/preview-whatsapp-carousel-template/:id"
            render={(props) => <WhatsAppCarouselTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/preview-whatsapp-carousel-template-copy/:copyid"
            render={(props) => <WhatsAppCarouselTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/create-copy-whatsapp-template/:templateid"
            render={(props) => <WhatsAppTemplateNew {...props} />}
          ></Route>
          <Protected
            exact
            path="/dashboard/whatsapp-optin-otpout"
            component={WhatsAppOptinOtpout}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-report"
            component={WhatsAppCountReports}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-gallery"
            component={WhatsAppGallery}
          />
          <Protected
            exact
            path="/dashboard/conversation-download"
            component={ConversationDownload}
          />
          <Route
            path="/dashboard/whatsapp/edit/:id"
            render={(props) => <WhatsappEnabaleNew {...props} />}
          ></Route>
          <Route
            path="/dashboard/preview-whatsapp-autentication/:id"
            render={(props) => <WhatsAppTemplateAuthentication {...props} />}
          ></Route>
          <Route
            path="/dashboard/whatsapp-detail-reports/:dateFrom/:dateTo"
            render={(props) => <WhatsappDetailReports {...props} />}
          ></Route>
          <Protected
            exact
            path="/dashboard/whatsapp-widget"
            component={WhatsappWidget}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-widget-steps/:id"
            component={WhatsappWidgetSteps}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-widget-data/:id"
            component={WhatsappWidgetData}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-widget/create"
            component={WhatsappWidgetData}
          />
          <Protected
            exact
            path="/dashboard/whatsapp-widget-qr-code"
            component={WhatsappWidgetQR}
          />
          <Protected
            exact
            path="/dashboard/widget-analytics"
            component={UserWidgetAnalytics}
          />
          {/* <Protected
            exact
            path="/dashboard/remove-branding"
            component={RemoveBranding}
          />  */}
          <Protected
            exact
            path="/dashboard/chat-setting/shortcuts"
            component={ChatSetting}
          />
          {/* rcs */}
          <AdminProtected
            exact
            path="/admin/rcs/rcs-setting-add"
            component={RcsAdminSetting}
          />
          <AdminProtected
            exact
            path="/admin/rcs/rcs-onboarding"
            component={AdminRcsOnboarding}
          />
          <AdminProtected
            exact
            path="/admin/admin-notification"
            component={AdminNotification}
          />
          <AdminProtected
            exact
            path="/admin/transaction-payment"
            component={AdminTransactionPayment}
          />

          <AdminProtected
            exact
            path="/admin/api-summary"
            component={AdminApiReport}
          />
          <AdminProtected
            exact
            path="/admin/karix-report"
            component={AdminKarixReport}
          />
          <AdminProtected
            exact
            path="/admin/campaign-summary-report"
            component={AdminCampaignSummaryReport}
          />
          <AdminProtected
            exact
            path="/admin/rcs/rcs-request-list"
            component={RcsOnboardingList}
          />
          <AdminProtected
            exact
            path="/admin/rcs/rcs-request-list-detail/:id"
            component={RcsRequestDetails}
          />
          <AdminProtected
            exact
            path="/admin/rcs/rcs-setting-list"
            component={RcsAdminSettingList}
          />
          {/* <AdminProtected
            exact
            path="/admin/rcs/rcs-filter"
            component={RcsAdminFilter}
          /> */}
          <AdminProtected
            exact
            path="/admin/rcs/rcs-setting-add/edit/:id"
            component={RcsAdminSetting}
          />
          <AdminProtected
            exact
            path="/admin/rcs/rcs-template-list"
            component={AdminRcsTemplateList}
          />
          <AdminProtected
            exact
            path="/admin/rcs/campaign-report"
            component={RcsAdminCampaignReport}
          />
          <AdminProtected
            exact
            path="/admin/schedule-campaign"
            component={ScheduleCampaign}
          />
          {/* <AdminProtected
            exact
            path="/admin/campaign/fallback-detailed-report/:channel/:id/:campaign_name/:contact_count"
            component={AdminSmsDetailReport}
          /> */}
          <AdminProtected
            exact
            path="/admin/campaign/detailed-report/rcs/:id/:campaignName/:contactcount/:fromdate/:todate/:username"
            component={RcsAdminDetailReport}
          />
          <Route
            path="/admin/rcs/preview-rcs-template/:id"
            render={(props) => <PreviewRcsTemplate {...props} />}
          ></Route>
          {/* outdated */}
          <Protected exact path="/dashboard/apply-rcs" component={RcsApply} />
          <Protected
            exact
            path="/dashboard/edit-rcs/:id"
            component={RcsApply}
          />
          <Protected
            exact
            path="/dashboard/rcs-list"
            component={RcsApplyedList}
          />
          <Protected
            exact
            path="/dashboard/create-rcs-template"
            component={RcsTemplate}
          />
          <Route
            path="/dashboard/create-rcs-template/edit/:id"
            render={(props) => <RcsTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/create-rcs-template/view/:viewid"
            render={(props) => <RcsTemplate {...props} />}
          ></Route>
          <Protected
            exact
            path="/dashboard/rcs-reports"
            component={RcsReport}
          />
          <Protected
            exact
            path="/dashboard/rcs-details-reports"
            component={RcsDetailsReport}
          />
          {/* <Protected
            exact
            path="/dashboard/rcs-template-list"
            component={RcsTemplateList}
          /> */}
          <Protected
            exact
            path="/dashboard/rcs-onboarding-list"
            component={RcsOnboarding}
          />
          <AdminProtected
            exact
            path="/admin/add-agent"
            component={RcsAddAgent}
          />
          <Route
            path="/dashboard/add-agent/edit/:id"
            render={(props) => <RcsAddAgent {...props} />}
          ></Route>
          <AdminProtected
            exact
            path="/dashboard/rcs-agent-list"
            component={RcsAgentList}
          />
          <AdminProtected
            exact
            path="/dashboard/rcs-pricing"
            component={RcsPlan}
          />
          <AdminProtected
            exact
            path="/dashboard/rcs-setting"
            component={RcsSetting}
          />
          <AdminProtected
            exact
            path="/admin/my-profile"
            component={AdminMyProfile}
          />
          <AdminProtected
            exact
            path="/admin/price-list"
            component={ResellerBillingHistory}
          />
          <AdminProtected
            exact
            path="/admin/change-password"
            component={AdminChangePassword}
          />
          <AdminProtected
            exact
            path="/admin/billing"
            component={AdminBilling}
          />
          <AdminProtected
            exact
            path="/admin/admin-billing-report"
            component={AdminBillingReport}
          />
          <AdminProtected
            exact
            path="/admin/admin-download-center"
            component={AdminDownloadCentre}
          />
          <AdminProtected
            exact
            path="/admin/admin-transaction-history/:id/:username"
            component={AdminBillingTransactionHistory}
          />
          {/* <AdminProtected
            exact
            path="/admin/admin-billing-report-estimate"
            component={EstimateReport}
          /> */}
          <AdminProtected
            exact
            path="/admin/vendor-summary"
            component={VendorSummary}
          />
          <AdminProtected
            exact
            path="/admin/encryption-setting"
            component={EncryptionSetting}
          />
          <AdminProtected
            exact
            path="/admin/reseller-site-settings"
            component={ResellerSiteSettings}
          />
          {/* <AdminProtected
            exact
            path="/admin/reseller-email-configuration"
            component={ResellerEmailConfiguration}
          /> */}
           <AdminProtected
            exact
            path="/admin/reseller-domain-configure"
            component={ResellerDomainConfigure}
          />
          <AdminProtected
            exact
            path="/admin/reseller-payment-gateway"
            component={ResellerPaymentGateway}
          />
          {/* Rich Media */}
          <Protected
            exact
            path="/dashboard/test-rich-media"
            component={TestRichMedia}
          />
          <Protected
            exact
            path="/dashboard/rich-media-template"
            component={RichMediaTemplateList}
          />
          <Protected
            exact
            path="/dashboard/rich-media-report"
            component={RichMediaReport}
          />
          <Protected
            exact
            path="/dashboard/create-rich-media-template"
            component={RichMediaTemplate}
          />
          <Route
            path="/dashboard/create-rich-media-template/edit/:id"
            render={(props) => <RichMediaTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/email-campaning/edit/:id"
            render={(props) => <EmailCampaign {...props} />}
          ></Route>
          <Route
            path="/dashboard/template-management/edit/:id"
            render={(props) => <TemplateManagement {...props} />}
          ></Route>
          <Protected
            exact
            path="/dashboard/email-html-editor"
            component={EmailHTMLEditor}
          />
          {userId ? (
            <Route
              path="/dashboard/sms-template/edit/:id"
              render={(props) => <SmsTemplate {...props} />}
            />
          ) : (
            <Route
              path="/dashboard/sms-template/edit/:id"
              render={(props) => <Login {...props} />}
            ></Route>
          )}
          <Route
            path="/dashboard/sms-template/edit/:id"
            render={(props) => <SmsTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/details-reports/:channel/:dateFrom/:dateTo"
            render={(props) => <ReportsDetails {...props} />}
          ></Route>
          <Route
            path="/dashboard/voice-detail-reports/:channel/:dateFrom/:dateTo"
            render={(props) => <VoiceDetailReports {...props} />}
          ></Route>
          <Route
            path="/dashboard/flash-call-detail-reports/:channel/:dateFrom/:dateTo"
            render={(props) => <FlashCallDetailReport {...props} />}
          ></Route>
          <Route
            path="/dashboard/email-detail-reports/:channel/:dateFrom/:dateTo"
            render={(props) => <EmailDetailReports {...props} />}
          ></Route>
          <Route
            path="/dashboard/sms-detail-reports/:channel/:dateFrom/:dateTo"
            render={(props) => <SmsDetailReports {...props} />}
          ></Route>
          <Route
            path="/dashboard/sms-template-summary"
            render={(props) => <SmsTemplateSummary {...props} />}
          ></Route>
          <Route
            path="/dashboard/voice-template/edit/:id"
            render={(props) => <VoiceTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/email-template/edit/:id"
            render={(props) => <EmailTemplate {...props} />}
          ></Route>
          <Route
            path="/dashboard/event-list/:id"
            render={(props) => <ProjectEventList {...props} />}
          ></Route>
          <Route
            path="/dashboard/create-new-event/:id"
            render={(props) => <CreateEvent {...props} />}
          ></Route>
          <Route
            path="/dashboard/create-new-fallback"
            render={(props) => <CreateFallBack {...props} />}
          ></Route>
          <Route
            path="/admin/user-entity-pass/:id/:userType"
            render={(props) => <EntityByPass {...props} />}
          />
          <Protected exact path="/logout" component={Logout} />
          {/* 
              <Route path="/dashboard/ticket/:id/:tiketid/:status" 
                render={props=>(<SupportHistory {...props}/>)}></Route> */}
          {userId ? (
            <Route
              path="/dashboard/ticket/:id/:tiketid/:status"
              render={(props) => <SupportHistory {...props} />}
            />
          ) : (
            <Route
              path="/dashboard/ticket/:id/:tiketid/:status"
              render={(props) => <Login {...props} />}
            ></Route>
          )}
          {/* for generate form Routes */}
          <Protected
            exact
            path="/dashboard/create-form"
            component={FormBuilder}
          />

          <Protected exact path="/dashboard/form-list" component={FormList} />

          <Route
            path="/dashboard/form/view/:id"
            render={(props) => <FormView {...props} />}
          ></Route>

          {/* Admin Routes */}
          <AdminProtected exact path="/admin" component={Admin} />
          {/*user Account Components*/}
          <AdminProtected
            exact
            path="/admin/user-management"
            component={UserManagement}
          />
          {/* <AdminProtected
            exact
            path="/admin/user-management-test"
            component={UsermanagementDemo}
          /> */}
          {/* <AdminProtected
            exact
            path="/admin/customer-data-dashboard"
            component={CustomerDataPlatform}
          /> */}
          <AdminProtected
            exact
            path="/admin/whatsapp-onboarding-list"
            component={EmployeeWhatsappOnboardingList}
          />
          <AdminProtected
            exact
            path="/admin/campaign-emp-report"
            component={EmployeesCampaignReport}
          />
          {/* <AdminProtected
            exact
            path="/admin/campaign-emp-summary"
            component={EmployeesCampaignSummary}
          /> */}
          <AdminProtected
            exact
            path="/admin/api-report"
            component={ApiReport}
          />
          {/* <AdminProtected
            exact
            path="/admin/user-dashboard"
            component={UserDashboard}
          /> */}
          <AdminProtected
            exact
            path="/admin/conversation-report"
            component={ConversationReport}
          />
          <AdminProtected
            exact
            path="/admin/billing-report"
            component={BillingReport}
          />
          <AdminProtected
            exact
            path="/admin/all-user-management"
            component={AllUserManagement}
          />
          <Route
            path="/admin/user-details/:id/:userType"
            render={(props) => <UserDetails {...props} />}
          />
          <Route
            path="/admin/api-auto-short-url/:id/:userType"
            render={(props) => <ApiAutoshortUrl {...props} />}
          />

          <Route
            path="/admin/extra-settings/:id/:userType"
            render={(props) => <ExtraSettings {...props} />}
          />
          {/* <Route
            path="/admin/extra-settings/:id/:userType"
            render={(props) => <ExtraSettings {...props} />}
          /> */}

          <Route
            path="/admin/mmlite/:id/:userType"
            render={(props) => <Mmlite {...props} />}
          />
          <Route
            path="/admin/ai-bot/:id/:userType"
            render={(props) => <AiBot {...props} />}
          />
          {/* <Route
            path="/admin/ivr-setting/:id/:userType"
            render={(props) => <IVRSetting {...props} />}
          /> */}
          <Route
            path="/admin/user-price-details/:id/:userType"
            render={(props) => <UserPriceDetails {...props} />}
          />
          <Route
            path="/admin/aws-settings/:id/:userType"
            render={(props) => <AwsSettings {...props} />}
          />
          <Route
            path="/admin/user-add-price/:id/:userType"
            render={(props) => <UserAddPrice {...props} />}
          />
          <Route
            path="/admin/reseller-billing-mode/:id/:userType"
            render={(props) => <BillingMode {...props} />}
          />
          <AdminProtected
            exact
            path="/admin/user-billing-mode/:id/:userType"
            component={UserBillingMode}
          />
          <Route
            path="/admin/change-currency/:id/:userType"
            render={(props) => <ChangeCurrency {...props} />}
          />
          <Route
            path="/admin/bulk-sms-route/:id/:userType"
            render={(props) => <BulkSmsRouteSetting {...props} />}
          />
          <Route
            path="/admin/user-transaction-details/:id/:userType"
            render={(props) => <UserTransactionDetails {...props} />}
          />
          <Route
            path="/admin/edit-employee/:id/:userType"
            render={(props) => <EditEmployee {...props} />}
          />
          <Route
            path="/admin/reseller-price-details/:id/:userType"
            render={(props) => <ResellerPriceDetails {...props} />}
          />
          <Route
            path="/admin/reseller-add-price/:id/:userType"
            render={(props) => <ResellerAddPrice {...props} />}
          />
          <Route
            path="/admin/reseller-transaction-details/:id/:userType"
            render={(props) => <ResellerTransactionDetails {...props} />}
          />
          <AdminProtected
            exact
            path="/admin/add-employee"
            component={AddEmployee}
          />
          {/* <AdminProtected
            exact
            path="/admin/add-sub-admin"
            component={AddSubAdmin}
          />
           <AdminProtected
            exact
            path="/admin/permissions"
            component={Permissions}
          /> */}
          <AdminProtected
            exact
            path="/admin/traffic-management"
            component={TrafficManagement}
          />
          <AdminProtected
            exact
            path="/admin/employee-management"
            component={EmployeeManagement}
          />
          <AdminProtected
            exact
            path="/admin/reseller-hierarchy"
            component={ResellerHierarchy}
          />
          <AdminProtected
            exact
            path="/admin/questionnaire-list"
            component={QuestionnaireList}
          />
          <AdminProtected
            exact
            path="/admin/api-failed-request"
            component={ApiFailedRequest}
          />
          <AdminProtected
            exact
            path="/admin/affiliate-management"
            component={AffiliateManagement}
          />
          <AdminProtected
            exact
            path="/admin/affilite-commision-hostory"
            component={AffiliateCommision}
          />
          <Route
            path="/admin/affiliate-payout/:id/:username/:amount"
            render={(props) => <AffiliatePayout {...props} />}
          ></Route>
          <Route
            path="/admin/affilite-commision-hostory/:id"
            render={(props) => <AffiliateCommision {...props} />}
          ></Route>
          <AdminProtected
            exact
            path="/admin/route-management"
            component={RouteManagement}
          />
          <AdminProtected
            exact
            path="/admin/add-new-route"
            component={AddNewRoute}
          />
          <AdminProtected
            exact
            path="/admin/login-history"
            component={LoginHistory}
          />
          <AdminProtected
            exact
            path="/admin/signup-history"
            component={SignupHistory}
          />
          <AdminProtected
            exact
            path="/admin/entity-history"
            component={EntityHistory}
          />
          <AdminProtected
            exact
            path="/admin/sernder-history"
            component={SernderHistory}
          />
          <AdminProtected
            exact
            path="/admin/sms-template-history"
            component={SmsTemplateHistory}
          />
          <AdminProtected
            exact
            path="/admin/spam-word"
            component={AddSpamWord}
          />
          <AdminProtected
            exact
            path="/admin/spam-report"
            component={SpamReport}
          />
          <AdminProtected
            exact
            path="/admin/api-request"
            component={ApiRequest}
          />
          <AdminProtected
            exact
            path="/admin/invalid-api-request"
            component={InvalidApiRequest}
          />
          <AdminProtected
            exact
            path="/admin/voice-template-history"
            component={VoiceTemplateHistory}
          />
          <AdminProtected
            exact
            path="/admin/email-template-history"
            component={EmailTemplateHistory}
          />
          <AdminProtected
            exact
            path="/admin/aws-setup-history"
            component={AwsSetupHistory}
          />
          <AdminProtected exact path="/admin/add-faq" component={AddFaq} />
          <AdminProtected exact path="/admin/faq-list" component={FaqList} />
          <AdminProtected
            exact
            path="/admin/feedback"
            component={FeedBackMessage}
          />
          <AdminProtected
            exact
            path="/admin/whatsapp-default-embeded-signup"
            component={DefaultEmbededSignup}
          />
          <AdminProtected
            exact
            path="/admin/whatsapp-account-list"
            component={WhatsappProfile}
          />
          {/* <AdminProtected
            exact
            path="/admin/whatsapp-summary"
            component={WhatsappSummary}
          /> */}
          <AdminProtected
            exact
            path="/admin/campaign-report"
            component={AdminCampaignReport}
          />
          <AdminProtected
            path="/admin/campaign-report/:camp_user_id/:camp_id/:camp_user_email/:totalData"
            component={CampaignReportWhatsApp}
          />
          <AdminProtected
            exact
            path="/admin/whatsapp-billing-summary"
            component={BillingSummary}
          />
          <AdminProtected
            exact
            path="/admin/live-whatsapp-widget"
            component={WhatsappWidgetStatus}
          />
          <AdminProtected
            exact
            path="/admin/widget-analytics"
            component={WidgetAnalytics}
          />
          <AdminProtected
            exact
            path="/admin/review-template"
            component={ReviewTemplate}
          />
          <AdminProtected
            exact
            path="/admin/queue-whatsapp-status"
            component={QueueStatusWhatsapp}
          />
          <AdminProtected
            exact
            path="/admin/whatsapp-setup"
            component={WhatsappSetup}
          />
          <AdminProtected
            exact
            path="/admin/pinnacle-embeded-signup"
            component={PinnacleEmbededSignup}
          />
          <AdminProtected
            exact
            path="/admin/karix-embeded-signup"
            component={KarixEmbededSignup}
          />
          <AdminProtected
            exact
            path="/admin/serri-embeded-signup"
            component={SerriEmbededSignup}
          />
          <AdminProtected
            exact
            path="/admin/karix-mmlite-signup"
            component={KarixMmliteSignup}
          />
          <AdminProtected
            exact
            path="/admin/karix-adz-signup"
            component={KarixSignupAdz}
          />
          <AdminProtected
            exact
            path="/admin/pinnacle-embeded-signup/register/:id/:wabaid/:pnid"
            component={PinnacleRegister}
          />
          <AdminProtected
            exact
            path="/admin/user-cdp"
            component={Usercdp}
          />
          <AdminProtected
            exact
            path="/admin/pinnacle-embeded-token"
            component={PinnacleEmbededToken}
          />
          <AdminProtected
            exact
            path="/admin/whatsapp-setup/details/:id"
            component={WhatsappSetupDetails}
          />
          <AdminProtected
            exact
            path="/admin/whatsapp-api"
            component={WhatsappSummaryApi}
          />
          <AdminProtected
            exact
            path="/admin/embeded-signup"
            component={EmbededSignup}
          />
          <AdminProtected
            path="/admin/whatsapp-account-setting/:id"
            render={(props) => <WhatsappSetting {...props} />}
          />
          <AdminProtected
            exact
            path="/admin/add-new-client"
            component={AddNewClient}
          />
          {/* <AdminProtected
            exact
            path="/admin/sub-admin"
            component={SubAdmin}
          /> */}
          <AdminProtected
            exact
            path="/admin/support"
            component={SupportTicket}
          />
          <AdminProtected
            exact
            path="/admin/delete-bounced-list"
            component={DeleteBouncedList}
          />
          <AdminProtected
            exact
            path="/admin/notification-setting"
            component={NotificationSetting}
          />
          <AdminProtected
            exact
            path="/admin/cross-origin"
            component={CrossOrigin}
          />
          <AdminProtected
            exact
            path="/admin/cdp-search"
            component={CdpSearch}
          />
          <AdminProtected
            exact
            path="/admin/entity-chain-management"
            component={EntityChainManagement}
          />
          <AdminProtected
            exact
            path="/admin/telemarketer"
            component={Telemarketer}
          />
          <AdminProtected
            exact
            path="/admin/manage-clip/:clipId"
            component={ManageClip}
          />
          <AdminProtected exact path="/admin/clip-list" component={ClipList} />
          <Route
            path="/admin/whatsapp-account-profile-details/:id"
            render={(props) => <ProfileDetails {...props} />}
          ></Route>
          <Route
            path="/admin/whatsapp-account-whatsapp-template-list/:id"
            render={(props) => <WhatsappTemplateSettingList {...props} />}
          ></Route>
          <Route
            path="/admin/whatsapp-account-update-whatsapp-token/:id"
            render={(props) => <UpdateWhatsappToken {...props} />}
          ></Route>
          <Route
            path="/admin/whatsapp-account-change-route/:id"
            render={(props) => <ChangeRouteSetting {...props} />}
          ></Route>
          <Route
            path="/admin/update-waba-id/:id"
            render={(props) => <UpdateWabaId {...props} />}
          ></Route>
          <Route
            path="/admin/mmlite-status/:id"
            render={(props) => <MmliteStatus {...props} />}
          ></Route>
          <Route
            path="/admin/mmlite-request/:id"
            render={(props) => <MmliteRequest {...props} />}
          ></Route>
          <AdminProtected
            exact
            path="/admin/blacklist-new"
            component={BlackList}
          />
          <AdminProtected
            exact
            path="/admin/sms-campaign-report"
            component={SmsCampaignReport}
          />
          <AdminProtected
            exact
            path="/admin/campaign/detailed-report/sms/:id/:username/:totalData"
            component={AdminSmsDetailReport}
          />
          <AdminProtected
            exact
            path="/admin/entity-management"
            component={EntityManagement}
          />
          <AdminProtected
            exact
            path="/admin/change-user-route"
            component={ChangeRoute}
          />
          <AdminProtected
            exact
            path="/admin/shift-router"
            component={ShiftRouter}
          />
          <AdminProtected
            exact
            path="/admin/lcr-route-setting"
            component={LcrRouteSetting}
          />
          <AdminProtected
            exact
            path="/admin/contact-us-enquiry"
            component={ContactUsEnquiry}
          />
          <AdminProtected
            exact
            path="/admin/client-transaction-history"
            component={AdminTransactionHistory}
          />
          <AdminProtected
            exact
            path="/admin/transaction-history"
            component={ResellerTransactionHistory}
          />
          {/* <AdminProtected
            exact
            path="/admin/rich-media"
            component={RichMediaManagement}
          /> */}
          <AdminProtected
            exact
            path="/admin/blacklist"
            component={AddBlackList}
          />
          <AdminProtected
            exact
            path="/admin/analytics"
            component={AdminAnalytics}
          />
           {/* <AdminProtected
            exact
            path="/admin/plan-list"
            component={PlansList}
          /> */}
          <AdminProtected
            exact
            path="/admin/agent-plan"
            component={AgentPlan}
          />
          <AdminProtected
            exact
            path="/admin/add-agent-plan"
            component={AddAgentPlan}
          />
          <AdminProtected
            exact
            path="/admin/add-agent-plan/:id"
            component={AddAgentPlan}
          />
          <AdminProtected
            exact
            path="/admin/agent-coupon"
            component={AgentCoupon}
          />
          <AdminProtected
            exact
            path="/admin/add-agent-coupon"
            component={AddAgentCoupon}
          />
          <AdminProtected
            exact
            path="/admin/add-agent-coupon/:id"
            component={AddAgentCoupon}
          />
          <AdminProtected
            exact
            path="/admin/agent-plan-list"
            component={AgentPlanList}
          />
          <AdminProtected
            exact
            path="/admin/agent-bill/:userId"
            component={AgentBillDetails}
          />
          <AdminProtected
            exact
            path="/admin/agent-bill"
            component={AgentBill}
          />
          <AdminProtected
            exact
            path="/admin/yearly-plan-settings"
            component={YearlyPlanSettings}
          />
          <AdminProtected
            exact
            path="/admin/yearly-agent-plan"
            component={YearlyAgentPlan}
          />
          <AdminProtected
            exact
            path="/admin/yearly-agent-plan/:id"
            component={YearlyAgentPlan}
          />
          <AdminProtected
            exact
            path="/admin/partner-dashboard"
            component={PartnerDashboard}
          />
          <AdminProtected
            exact
            path="/admin/ai-bot-usage-overview"
            component={AiBotUsageOverview}
          />
          <AdminProtected
            exact
            path="/admin/payment-gateway-list"
            component={PaymentGatewayList}
          />
          <AdminProtected
            exact
            path="/admin/user-activity-log"
            component={Useractivitylog}
          />
          <AdminProtected
            exact
            path="/admin/user-journey/:id"
            component={UserJourney}
          />
          <AdminProtected
            exact
            path="/admin/activity-log-buckets"
            component={ActivityLogBuckets}
          />
          <AdminProtected
            exact
            path="/admin/reseller-setting"
            component={ResellerSetting}
          />
          <AdminProtected
            exact
            path="/admin/integration/panel"
            component={AdminIntegrationPanel}
          />
          <AdminProtected
            exact
            path="/admin/integration/event"
            component={AdminEventPanel}
          />
          <AdminProtected
            exact
            path="/admin/assign-plan"
            component={AssignPlan}
          />
          <AdminProtected
            exact
            path="/admin/download-hide"
            component={DownloadHide}
          />
          <AdminProtected
            exact
            path="/admin/download-hide/:id"
            component={DownloadHide}
          />
          <AdminProtected exact path="/admin/add-blog" component={AddBlog} />
          <Route
            path="/admin/edit-blog/:id"
            render={(props) => <AddBlog {...props} />}
          ></Route>
          <AdminProtected exact path="/admin/blog-list" component={BlogList} />
          <Route
            path="/admin/rich-media-view-template/:id"
            render={(props) => <RichMediaViewTemplate {...props} />}
          ></Route>
          <Route
            path="/admin/edit-route/:id"
            render={(props) => <EditRoute {...props} />}
          ></Route>
          <Route
            path="/admin/support/edit/:id/:ticketnumber/:replyuserid"
            render={(props) => <ViewTicket {...props} />}
          ></Route>
          <Route
            path="/admin/add-faq/edit/:id"
            render={(props) => <AddFaq {...props} />}
          ></Route>
          <Route
            path="/admin/api-request/:username"
            render={(props) => <ApiRequest {...props} />}
          ></Route>
          <AdminProtected exact path="/admin/logout" component={Logout} />
          <Route exact path="/page-not-found" component={PageNotFound}></Route>
          <Route exact component={Error}></Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
